export function stringNormalize(string: string): string {
  // in order: double quotation marks, single quotation marks and apostrophes, commas, ellipsis, em/en dashes
  return string
    .replace(/[\u201C\u201D\u02DD\u0308\u00A8]/g, '\u0022')
    .replace(/[\u00B4\u0060\u2018\u2019\u0301\u02BB\u02C8\u02BC]/g, '\u0027')
    .replace(/[\u02CC\u201A\uFF0C\u3001]/g, '\u002C')
    .replace(/\u2026/g, '...')
    .replace(/\u2014/g, '--')
    .replace(/\u2013/g, '-');
}
